import React from "react"
import ModuleType1 from "./module-type-1"
import ModuleType2 from "./module-type-2"
import QuoteModule from "./quote-module"

const getModuleRep = (type, module, pageData) => {
  switch (type) {
    case "ContentfulV4CaseStudyPagesModule1":
      return <ModuleType1 data={module} mod={pageData} />
    case "ContentfulV4CaseStudyPagesModule2":
      return <ModuleType2 data={module} mod={pageData} />
    case "ContentfulV4CaseStudyPagesQuoteModule":
      return <QuoteModule data={module} />
    default:
      return <></>
  }
}

const CaseStudy = ({ mod }) => (
  <div>
    {mod.modules.map((current, idx) => (
      <React.Fragment key={idx}>
        {getModuleRep(current.internal.type, current, mod)}
      </React.Fragment>
    ))}
  </div>
)

export default CaseStudy
